/* eslint-disable class-methods-use-this */
import {createImgIn, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils.ts'
import {UIAdController} from '../../../shared/scripts/ui_ad/UIAdController.ts'
import {logError} from '../../../shared/scripts/ui_utils/Utils.ts'
import {type UIMManager} from '../ui_html/UIMManager.ts'
import {LobbyImage} from '@colonist/types'
import {ClientUserState} from '../../../shared/scripts/ClientUserState.ts'
import {UIMMobileWebviewCommunication} from '../ui_mobile_communication/UIMMobileWebviewCommunication.ts'
import {MobileWebviewCommunicationActions} from '@colonist/mobile'
import {CA} from '../../../shared/scripts/analytics/Analytics.ts'
import {AnalyticEventCategory, AnalyticEventType, AnalyticEventValue} from '../../../../shared/entity_datas/EntityDatas.ts'
import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {UIMSceneEnum} from '../../../../shared/enums/UIMSceneEnums.ts'

interface AdElement {
    id: string
    imgSrc: LobbyImage
    onClick: () => void
}
export class UIMAdController extends UIAdController {
    private readonly uiManager: UIMManager
    private gameMenuAdElements: AdElement[] = []
    private showAdsOnGameMenu: boolean
    private mutationObserver: MutationObserver

    constructor(uiManager: UIMManager) {
        super()
        this.uiManager = uiManager
        this.showAdsOnGameMenu = false

        this.initializeGameMenuAdElements()
        // this.initializeMutationObserver()
        this.loadAbMobBannerAdsForGameMenu()
    }

    private initializeGameMenuAdElements() {
        const hasMembership = ClientUserState.userState?.items.hasMembership()
        if(hasMembership) return

        this.gameMenuAdElements = [
            {
                id: 'profile-banner-ad',
                imgSrc: LobbyImage.BannerMember,
                onClick: async() => {
                    const eventData: AjaxDataTypes.AnalyticData = {
                        type: AnalyticEventType.ABTestClickAnalytics,
                        category: AnalyticEventCategory.ABTestClickAnalytics,
                        floatValue: AnalyticEventValue.MobileProfilePageBecomeAMemberBanner,
                    }
                    await CA.sendAnalyticEvent(eventData)
                    this.uiManager.sceneController.loadScene(UIMSceneEnum.Store)
                },
            },
        ]

        this.gameMenuAdElements.forEach((adElement) => {
            const element = document.getElementById(adElement.id)
            if(element == undefined) return
            createImgIn(element, adElement.imgSrc)
            setElementOnClick(element, adElement.onClick)
        })
    }

    private initializeMutationObserver() {
        const hasMembership = ClientUserState.userState?.items.hasMembership()
        if(hasMembership) return

        const splideListComponent = document.getElementById('splide01-list')
        if(!splideListComponent) return

        this.mutationObserver = new MutationObserver((entries: MutationRecord[]) => {
            if(!this.showAdsOnGameMenu) return

            this.gameMenuAdElements.forEach((adElement) => {
                this.sendBannerPositionToMobile(adElement.id, true)

                if(!splideListComponent.style.transition) return

                const interval = setInterval(() => {
                    if(!splideListComponent.style.transition) clearInterval(interval)
                    else this.sendBannerPositionToMobile(adElement.id, true)
                }, 20)
            })
        })

        this.mutationObserver.observe(splideListComponent, {
            attributes: true,
        })
    }

    private sendBannerPositionToMobile(id: string, isVisible: boolean) {
        const element = document.getElementById(id)
        if(!element) return
        const {x, y, width, height} = element.getBoundingClientRect()
        const padding = Math.round(document.documentElement.clientWidth * 0.05)
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.BannerAd, {
            id: id,
            x: x - padding,
            y: y,
            width: width + padding * 2,
            height: height,
            visible: isVisible,
        })
    }

    loadAbMobBannerAdsForGameMenu() {
        const hasMembership = ClientUserState.userState?.items.hasMembership()
        if(hasMembership) return

        this.showGameMenuAdMobBannerAds(true)
        this.showSingletonPageAdMobBannerAds(false)
    }

    loadAbMobBannerAdsForSingletonPage() {
        const hasMembership = ClientUserState.userState?.items.hasMembership()
        if(hasMembership) return

        this.showGameMenuAdMobBannerAds(false)
        this.showSingletonPageAdMobBannerAds(true)
    }

    private showGameMenuAdMobBannerAds(isVisible: boolean) {
        this.showAdsOnGameMenu = isVisible
        // this.gameMenuAdElements.forEach((adElement) => {
        //     this.sendBannerPositionToMobile(adElement.id, isVisible)
        // })
    }

    hideAllAds() {
        this.showGameMenuAdMobBannerAds(false)
        this.showSingletonPageAdMobBannerAds(false)
    }

    private showSingletonPageAdMobBannerAds(isVisible: boolean) {
        const width = document.documentElement.clientWidth
        const height = width / 320 * 50
        const x = 0
        const y = document.documentElement.clientHeight - height
        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.BannerAd, {
            id: 'matchmaking-ad',
            x: x,
            y: y,
            width: width,
            height: height,
            visible: isVisible,
        })
    }

    // TODO rename this to more generic
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    showLobbyVerticalAds() { }
    removeLobbyAds() {
        logError('removeLobbyAds', ['No ads to remove'])
    }
    showInGameAds() {
        logError('showInGameAds', ['No ads to show'])
    }
    hideInGameAds() {
        logError('hideInGameAds', ['No ads to remove'])
    }
    showBannerAds() {
        return
    }
    hideBannerAds() {
        return
    }
}
